/* eslint-disable jsx-a11y/accessible-emoji */

/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import styled, { th, x } from '@xstyled/styled-components';
import { ScreenContainer } from './ScreenContainer';
var InnerFeature = styled.box.withConfig({
  displayName: "Feature__InnerFeature",
  componentId: "sc-17n9iec-0"
})(["border-left:1;border-left-style:dashed;border-left-color:layout-border;padding-right:5 !important;"]);
export var Feature = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(InnerFeature, Object.assign({
    ref: ref,
    col: {
      xs: 1,
      md: 1 / 4
    },
    px: 2,
    pt: 4,
    pb: {
      xs: 2,
      md: 5
    }
  }, props));
});
export var FeatureTitle = styled.h2.withConfig({
  displayName: "Feature__FeatureTitle",
  componentId: "sc-17n9iec-1"
})(["margin:3 0;font-size:16;font-weight:500;border-left:1;border-color:primary-400;margin-left:", ";padding-left:", ";"], th.px(-9), th.px(9));
export var FeatureText = styled.p.withConfig({
  displayName: "Feature__FeatureText",
  componentId: "sc-17n9iec-2"
})(["color:on-background-light;font-size:15;text-align:justify;margin:4 0;"]);
var InnerFeatureImage = styled.img.withConfig({
  displayName: "Feature__InnerFeatureImage",
  componentId: "sc-17n9iec-3"
})(["margin-top:3;"]);
export var FeatureImage = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(InnerFeatureImage, Object.assign({
    ref: ref,
    width: 48,
    height: 48
  }, props));
});
export var FeatureList = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(ScreenContainer, Object.assign({
    ref: ref,
    row: true,
    my: -4,
    px: 3
  }, props));
});
export var FeatureSection = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(x.section, Object.assign({
    ref: ref,
    py: 4,
    borderTop: 1,
    borderBottom: 1,
    borderColor: "layout-border"
  }, props));
});